import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { submitReport } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";
import { toast } from "sonner";

export default function ReportError() {
  const { t, locale } = useI18n();
  const [params] = useSearchParams();
  const [state, setState] = useState({
    brand_slug: params.get("brand") || "",
    category_hint: "",
    description: "",
    link: "",
    email: "",
  });
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await submitReport(state);
      setDone(true);
      toast.success(t.report_confirm);
    } catch { toast.error("Failed"); }
  };
  return (
    <>
      <Seo title={t.report_title} description={t.report_intro} canonicalPath="/report-error" locale={locale} />
      <div className="bp-container py-16 max-w-2xl">
        <h1 className="font-serif text-4xl md:text-5xl mb-4">{t.report_title}</h1>
        <p className="mb-8" style={{ color: "var(--bp-text-secondary)" }}>{t.report_intro}</p>
        {done ? (
          <div className="p-6 bg-white border" style={{ borderColor: "var(--bp-border)" }} data-testid="report-thanks">
            {t.report_confirm}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest">Brand slug</label>
              <Input required value={state.brand_slug} onChange={(e) => setState({ ...state, brand_slug: e.target.value })} data-testid="re-brand" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest">{t.report_field_item}</label>
              <Input value={state.category_hint} onChange={(e) => setState({ ...state, category_hint: e.target.value })} data-testid="re-item" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest">{t.report_field_desc}</label>
              <Textarea required value={state.description} onChange={(e) => setState({ ...state, description: e.target.value })} data-testid="re-desc" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest">{t.report_field_link}</label>
              <Input value={state.link} onChange={(e) => setState({ ...state, link: e.target.value })} data-testid="re-link" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest">{t.report_field_email}</label>
              <Input type="email" value={state.email} onChange={(e) => setState({ ...state, email: e.target.value })} data-testid="re-email" />
            </div>
            <Button type="submit" className="rounded-none" data-testid="re-submit">{t.report_submit}</Button>
          </form>
        )}
      </div>
    </>
  );
}
